import Nav from "@/components/zavico/Nav";
import Hero from "@/components/zavico/Hero";
import Marquee from "@/components/zavico/Marquee";
import Manifesto from "@/components/zavico/Manifesto";
import Transmission from "@/components/zavico/Transmission";
import NotifyForm from "@/components/zavico/NotifyForm";
import Footer from "@/components/zavico/Footer";

export default function Landing() {
  return (
    <main className="bg-[#030305] text-[#f8f9fa] relative">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Transmission />
      <NotifyForm />
      <Footer />
    </main>
  );
}
